import React from "react"
import Admon from "../components/Admon"
import Card from "../components/Card"


const PageAdmon =()=>{

    return(
        <div>
            <Admon/>
             <Card />
        </div>
    )

}


export default PageAdmon
